import { useGalleryToImageProps } from './useGalleryToImageProps';

import type { AiPicture, Hotel } from '~~/domains/graphql';

type HotelIntro = {
  images: AiImageProps[];
};

export function useHotelIntro(
  hotel: Ref<Hotel | null | undefined>,
): ComputedRef<HotelIntro> {
  return computed<HotelIntro>(() => {
    const images = useGalleryToImageProps(
      hotel.value?.galleryImages as AiPicture[],
    );

    return {
      images,
    };
  });
}
